import { BaseFileUploader } from '@/abstracts/base-file-uploader';
import { dataURLtoBlob } from '@/helpers/image.helper';
import { ProcessorType, type UploadingOptions } from '@/services/types/file-uploader.types';
import type { FileVersion } from '@/services/types/file.types';

export class FileUploaderV1 extends BaseFileUploader {
  public constructor(version: FileVersion) {
    super(version);
  }

  public async upload(options: UploadingOptions): Promise<void> {
    const formData = new FormData();
    switch (options.processorType) {
      case ProcessorType.Formidable: {
        if (options.data) formData.append('data', JSON.stringify(options.data));
        if (options.files) options.files.forEach((x) => formData.append('files', x));
        if (options.image) formData.append('image', dataURLtoBlob(options.image));
        break;
      }
      case ProcessorType.Multer: {
        if (options.file) formData.append('file', options.file);
        if (options.image) formData.append('file', dataURLtoBlob(options.image));
        break;
      }
    }
    if (!options.method) return;
    await options.method(options.url, formData, 'json', { 'x-file-uploader-version': this._version });
  }
}
